module.exports = __webpack_public_path__ + "static/media/Selbstfahrer.f74f99b9.png";